import { useCallback } from "react";

import type { SiteControllerType } from "@/lib/gql/__generated__/graphql";

import type { SiteControllerSettingBaseFormModel } from "../../../type";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"];
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export type SiteControllerSettingBaseFormModelMethodsType = {
	siteControllerSettingBaseFormModelMethods: {
		onSetSiteControllerType: (value: SiteControllerType) => void;
	};
};

type UseSiteControllerSettingBaseFormModelMethodsType = ({
	viewModel,
	onSetViewModel,
}: Props) => SiteControllerSettingBaseFormModelMethodsType;

export const useSiteControllerSettingBaseFormModelMethods: UseSiteControllerSettingBaseFormModelMethodsType = ({
	viewModel,
	onSetViewModel,
}) => {
	const onSetSiteControllerType = useCallback(
		(value: SiteControllerType) => {
			onSetViewModel([
				{
					key: "siteControllerType",
					value: {
						...viewModel.siteControllerType,
						value,
					},
				},
			]);
		},
		[viewModel.siteControllerType, onSetViewModel],
	);

	return {
		siteControllerSettingBaseFormModelMethods: {
			onSetSiteControllerType, //
		},
	};
};
